module.exports = __webpack_public_path__ + "static/media/amSpeech.440a4307.jpg";